import React, { Component } from 'react'
import { Table } from 'antd'
import moment from 'moment'

class ListRepairOrderEstimates extends Component {
  getColumns = () => {
    return [
      {
        title: 'Id',
        dataIndex: 'job',
        render: item => {
          if (item && item.job_type) {
            let jobUrl = `/jobView/${item.job_id}/${item.job_type.replace(
              '/',
              '-'
            )}/site-estimates/modal/${item.id}`
            return (
              <a href={jobUrl} target="_blank">
                {item.id}
              </a>
            )
          }
        }
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date'
      }
    ]
  }

  getData = () => {
    const { repairOrderEstimates } = this.props

    const data = repairOrderEstimates.map((repairOrderEstimate, index) => {
      // format date from db
      repairOrderEstimate.created_date = moment(new Date(repairOrderEstimate.created_date)).format(
        'YYYY-MM-DD'
      )
      const returnObj = Object.assign(
        {
          key: `${repairOrderEstimate.id}${index}`,
          job: {
            job_id: repairOrderEstimate.job_id,
            job_type: repairOrderEstimate.job_type,
            number: repairOrderEstimate.number,
            id: repairOrderEstimate.id
          }
        },
        repairOrderEstimate
      )
      return returnObj
    })
    return data
  }

  render() {
    return (
      <div>
        <h6>Repair Order Estimates</h6>
        <Table
          pagination={false}
          columns={this.getColumns()}
          dataSource={this.getData()}
          size="small"
          style={{ backgroundColor: 'white' }}
        />
      </div>
    )
  }
}

export default ListRepairOrderEstimates



// WEBPACK FOOTER //
// ./src/components/reports/general/open-items/ListRepairOrderEstimates.js